{
	"version": "1.0.0",
	"deprecatedStores": ["SomeStore", "ToDoList"]
}
